import { moduleFactory } from "@/factories/module";
import { _fetchPusherClientInstance } from "@/modules/pusher-client/clientInstance";
import { _initializePusher } from "@/modules/pusher-client/initialize";

export const pusherClientModule = moduleFactory.create({
  initialize: _initializePusher,
  client: _fetchPusherClientInstance,
});
